import { SFITokenAddress } from 'utils/constants/addresses';
import { useState } from 'react';
import { TokenAddressesDropDown } from 'structure/home/components/TokenAddressesDropDown';

export const TokenAddresses = () => {
  const [value, setValue] = useState<string>('1');

  return (
    <div className='flex flex-col gap-2 px-4 lg:px-0'>
      <div className='flex flex-wrap gap-2 md:justify-start'>
        <TokenAddressesDropDown
          value={value}
          onChange={setValue}
          options={Object.entries(SFITokenAddress).map(([chainId, token]) => ({
            token: token,
            chainId: chainId,
          }))}
        />
      </div>
    </div>
  );
};
